import { render, staticRenderFns } from "./modal_trademark.vue?vue&type=template&id=6476db65&scoped=true&"
import script from "./modal_trademark.vue?vue&type=script&lang=js&"
export * from "./modal_trademark.vue?vue&type=script&lang=js&"
import style0 from "./modal_trademark.vue?vue&type=style&index=0&id=6476db65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476db65",
  null
  
)

export default component.exports